import React, { useState, useEffect } from "react";
// import "../Styles/globals.css";
import { toAbsoluteUrl } from "../../toAbsoluteUrl";
import { callApi } from "../../API";
import Pagination from "../../Components/pagination";
import { useNavigate, useParams } from "react-router-dom";
import BreadcrumbsComponent from "../../Components/Breadcrumbs.jsx";
import WalletInformation from "./components/walletInformation.jsx";
import WalletTransaction from "./components/walletTransaction.jsx";
import OrdersAndReservations from "./components/ordersAndReservation.jsx";
import TopUpWallet from "./components/topUpWallet.jsx";
import { useSearchParams } from "react-router-dom";

export default function Finance() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [open, setOpen] = useState(false);
  const [activePage, setActivePage] = useState(0);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(0);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [firstLoad, setFirstLoad] = useState(true);
  const [firstLoadNoData, setFirstLoadNoData] = useState(false);
  const [transactionId, setTransactionId] = useState('');
  const [statusOfPayment, setStatusOfPayment] = useState(false);
  const [breadCrump, setBreadCrump] = useState([
    { name: "Home", link: "/" },
    { name: "Finances", link: "businessDashboard/Finance" },
  ]);
  // const { id, status } = useParams();

  useEffect(() => {  
    const id = searchParams.get('id');
    const status = searchParams.get('status');
    if (id!= null && status !=null) {
      setOpen(true);
      setTransactionId(id)
setStatusOfPayment(status)
    }
  }, []);

  const handleClose = () => {
    console.log('dddddddd');
    
    setOpen(false)
    setTransactionId('')
    setStatusOfPayment(false)
  
  };
  const handleOpen = () => setOpen(true);

  function switchPageView(params) {
    if (activePage != params) {
      setActivePage(params);
    }
  }

  return (
    <div className="container">
      <div>
        <BreadcrumbsComponent pages={breadCrump} />
        <div className="header-of-page display-flex-with-space-between">
          <h1>Finances</h1>
        </div>
        <WalletInformation handleOpen={handleOpen} />
        <div className="divider d-md-none d-block mt-4" />
        <div className="nav-items mt-5">
          <p
            className={`item-of-nav ${activePage == 0 ? "active" : ""}`}
            onClick={() => switchPageView(0)}
          >
            Wallet Transactions
          </p>
          <p
            className={`item-of-nav ${activePage == 1 ? "active" : ""}`}
            onClick={() => switchPageView(1)}
          >
            Orders and Reservations
          </p>
        </div>
        {loading == 1 ? (
          <div className="display-flex-with-center justify-content-center mt-5">
            <div class="spinner-border" role="status">
              <span class="sr-only"></span>
            </div>
          </div>
        ) : (
          <>
            {activePage == 0 ? (
              <WalletTransaction />
            ) : (
              <OrdersAndReservations />
            )}
            {open && <TopUpWallet transactionId ={transactionId} statusOfPayment={statusOfPayment} closeModal={handleClose} open={open} />}
          </>
        )}
      </div>
    </div>
  );
}
